var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 190,
    viewBox: "0 0 284 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.937 92.6607C227.987 73.2462 201.693 21.3699 149.788 21.76C125.648 21.9424 124.039 33.9817 102.694 43.9818C89.9719 49.9417 73.55 52.3728 65.5883 64.25C58.7132 74.5008 57.1465 87.2964 60.7322 97.0241C68.7959 118.902 92.2606 139.358 127.501 119.521C162.741 99.6837 202.75 142.73 220.937 92.6607Z",
    fill: "url(#paint0_linear_573_9373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.919 148.856C181.334 136.955 196.25 124.197 212.366 120.271C228.99 116.218 230.356 121.839 229.279 129.9C228.202 137.962 218.799 155.221 196.205 160.403C173.605 165.588 153.429 159.994 166.919 148.856Z",
    fill: "url(#paint1_linear_573_9373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5264 104.806C81.6008 111.68 108.048 118.435 125.455 133.662C143.416 149.366 138.148 155.444 128.15 160.699C118.152 165.955 91.0397 169.107 66.9978 147.501C42.9493 125.889 33.0604 98.3759 56.5264 104.806Z",
    fill: "url(#paint2_linear_573_9373)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.757 79.194C201.489 81.9368 204.298 83.5644 207.031 82.8295C209.765 82.0946 211.386 79.2754 210.654 76.5326C209.922 73.7899 207.112 72.1622 204.379 72.8971C201.646 73.632 200.024 76.4512 200.757 79.194Z",
    fill: "#E1E4E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.636 68.4298C128.926 47.251 104.757 37.1678 83.6524 45.9083C62.548 54.6488 52.5002 78.9031 61.21 100.082L64.3641 107.751C73.0739 128.93 97.2432 139.013 118.348 130.273C139.452 121.532 149.5 97.278 140.79 76.0993L137.636 68.4298Z",
    fill: "#434343"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0612 84.896C94.3118 84.3781 94.9072 82.9408 94.3911 81.6858C93.8749 80.4308 92.4427 79.8333 91.1921 80.3513C89.9415 80.8692 89.3461 82.3064 89.8623 83.5614C90.3784 84.8164 91.8106 85.4139 93.0612 84.896Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.769 77.2969C115.941 77.4991 115.128 77.7608 114.337 78.08C109.572 80.0132 105.905 83.9782 104.305 88.9274C102.705 93.8763 103.333 99.3112 106.024 103.795",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.065 78.0326C120.063 82.8918 120.057 88.3487 118.046 93.2029C116.035 98.0569 112.185 101.91 107.342 103.916V103.916C104.945 104.909 102.376 105.418 99.782 105.415C97.1883 105.412 94.6205 104.896 92.2255 103.896C89.8304 102.897 87.655 101.434 85.8234 99.5914C83.9917 97.7485 82.5398 95.5615 81.5504 93.1554V93.1554C80.5609 90.7494 80.0533 88.1713 80.0567 85.5685C80.06 82.9656 80.5741 80.3889 81.5698 77.9855C82.5655 75.582 84.0231 73.3989 85.8595 71.5608C87.6959 69.7227 89.8751 68.2656 92.2727 67.2726V67.2726C94.6703 66.2796 97.2393 65.7701 99.833 65.7735C102.427 65.7768 104.994 66.2927 107.39 67.2919C109.785 68.2911 111.96 69.7539 113.792 71.5968C115.623 73.4397 117.075 75.6266 118.065 78.0326V78.0326Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M205.468 133.266C210.024 116.204 199.934 98.6661 182.932 94.0943C165.929 89.5225 148.453 99.6479 143.898 116.71L142.676 121.287C138.12 138.349 148.21 155.886 165.212 160.458C182.214 165.03 199.69 154.905 204.246 137.843L205.468 133.266Z",
    fill: "#434343"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.61 121.929C171.618 122.2 172.653 121.6 172.923 120.589C173.193 119.578 172.595 118.539 171.588 118.268C170.58 117.997 169.545 118.597 169.275 119.608C169.005 120.619 169.603 121.658 170.61 121.929Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.673 128.427C188.072 128.161 187.452 127.939 186.819 127.762C182.998 126.705 178.902 127.409 175.612 129.687C172.322 131.965 170.169 135.588 169.723 139.598",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.125 129.486C188.608 131.425 187.715 133.242 186.497 134.834C185.28 136.426 183.762 137.762 182.03 138.765C180.299 139.768 178.387 140.419 176.404 140.681C174.422 140.943 172.407 140.811 170.476 140.291V140.291C168.544 139.772 166.733 138.876 165.147 137.654C163.56 136.433 162.229 134.909 161.229 133.172C160.23 131.434 159.581 129.515 159.32 127.526C159.059 125.536 159.191 123.515 159.708 121.576V121.576C160.754 117.661 163.305 114.324 166.803 112.297C168.535 111.294 170.446 110.642 172.429 110.381C174.412 110.119 176.426 110.251 178.358 110.771C180.289 111.29 182.1 112.186 183.687 113.408C185.273 114.629 186.605 116.152 187.605 117.89C188.604 119.628 189.253 121.547 189.514 123.537C189.775 125.526 189.643 127.548 189.125 129.486V129.486Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.124 42.8876L174.124 42.8876C164.085 40.1882 153.767 46.1666 151.077 56.2406L149.394 62.5417C146.705 72.6157 152.662 82.9706 162.701 85.6699L162.701 85.67C172.74 88.3693 183.058 82.3909 185.748 72.3169L187.43 66.0158C190.12 55.9418 184.163 45.587 174.124 42.8876Z",
    fill: "#434343"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 59.3227C167.444 59.4826 168.056 59.1284 168.215 58.5313C168.375 57.9343 168.022 57.3207 167.427 57.1607C166.832 57.0008 166.22 57.3551 166.061 57.9521C165.902 58.5491 166.255 59.1627 166.85 59.3227Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.515 63.1566C177.16 62.9998 176.794 62.8688 176.42 62.7646C174.165 62.1404 171.746 62.5559 169.804 63.9008C167.861 65.2456 166.59 67.3847 166.326 69.7528",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.781 63.7837C177.164 66.095 175.657 68.0655 173.592 69.2619C171.527 70.4583 169.073 70.7825 166.77 70.1633V70.1633C165.629 69.8568 164.56 69.3278 163.623 68.6066C162.686 67.8853 161.9 66.9859 161.31 65.9598C160.72 64.9337 160.336 63.8009 160.182 62.6261C160.028 61.4514 160.106 60.2577 160.412 59.1132V59.1132C160.718 57.9687 161.245 56.8958 161.963 55.9558C162.682 55.0157 163.578 54.2269 164.601 53.6345C165.623 53.0421 166.752 52.6576 167.923 52.5029C169.093 52.3483 170.283 52.4266 171.423 52.7333V52.7333C173.727 53.3528 175.69 54.865 176.883 56.9373C178.075 59.0096 178.398 61.4723 177.781 63.7837V63.7837Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_9373",
    x1: 210.83,
    y1: -39.6936,
    x2: 39.2757,
    y2: 263.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_9373",
    x1: 165.724,
    y1: 200.327,
    x2: 243.181,
    y2: 50.1519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_573_9373",
    x1: -2.73935,
    y1: 144.838,
    x2: 229.604,
    y2: 111.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.1482ac361bbb965faa7b6476cdcb1c40.svg";
export { ForwardRef as ReactComponent };